import UnconfirmedPayments from "./UnconfirmedPayments";
import CreatePayment from "./CreatePayment";
import UnmatchedRefundTransaction from "./UnmatchedRefundTransaction";
import FeeTransaction from "./FeeTransaction";
import BNPLDeferredInterestTransaction from "./CreateBNPLDeferredInterestTransaction";
import {useState} from "react";
import CreateAdjustment from "./CreateAdjustment";
import CreateInterestTransaction from "./CreateInterestTransaction";
import CreatePurchaseTransaction from "./CreatePurchaseTransaction";
import OtherTransactions from "./OtherTransactions";

export default function Transactions() {
    const [paymentCreated, setPaymentCreated] = useState('');
    const paymentCreatedCallback = (paymentCreated) => setPaymentCreated(paymentCreated);

    return (
        <section>
            <div className="ui grid">
                <div className="three wide column">
                    <CreateAdjustment/>
                    <CreateInterestTransaction/>
                </div>
                <div className="ten wide column">
                    <UnconfirmedPayments paymentCreated={paymentCreated}/>
                    <OtherTransactions/>
                </div>
                <div className="three wide column">
                    <div className="ui cards">
                        <CreatePayment paymentCreated={paymentCreatedCallback} />
                    </div>
                    <UnmatchedRefundTransaction/>
                    <FeeTransaction/>
                    <BNPLDeferredInterestTransaction/>
                    <CreatePurchaseTransaction/>
                </div>
            </div>
        </section>
        );
}